
      import { XGAME_ACHIEVEMENTS, getEarnedAchievements, getRankAndCounts } from "/src/site/achievements.ts";
      import { getProfile } from "/src/site/profile.ts";

      const GAMES = [
        { id: "drift",      name: "Drift",      path: "/" },
        { id: "pulse",      name: "Pulse",      path: "/pulse" },
        { id: "bulwark",    name: "Bulwark",    path: "/bulwark" },
        { id: "echo",       name: "Echo",       path: "/echo" },
        { id: "spire",      name: "Spire",      path: "/spire" },
        { id: "quickdraw",  name: "Quickdraw",  path: "/quickdraw" },
        { id: "foraging",   name: "Foraging",   path: "/foraging" },
        { id: "ascent",     name: "Ascent",     path: "/ascent" },
        { id: "lattice",    name: "Lattice",    path: "/lattice" },
        { id: "sigil",      name: "Sigil",      path: "/sigil" },
        { id: "resonance",  name: "Resonance",  path: "/resonance" },
        { id: "frequency",  name: "Frequency",  path: "/frequency" },
        { id: "hailstorm",  name: "Hailstorm",  path: "/hailstorm" },
      ];
      const today = new Date().toISOString().slice(0, 10);
      document.getElementById("daily-date").textContent = today;

      let progress = { date: today, completed: [], scores: {} };
      try {
        const raw = localStorage.getItem("aether.daily");
        if (raw) {
          const p = JSON.parse(raw);
          if (p.date === today) progress = p;
        }
      } catch {}

      const list = document.getElementById("daily-list");
      for (const g of GAMES) {
        const done = progress.completed.includes(g.id);
        const score = progress.scores[g.id];
        const a = document.createElement("a");
        a.className = "daily-card" + (done ? " completed" : "");
        a.href = `${g.path}?daily=${today}`;
        a.innerHTML = `<span class="name">${g.name}</span>` +
          (done ? `<span class="score">${score?.toLocaleString() ?? "✓"}</span>` : "");
        list.appendChild(a);
      }

      // Profile + achievements panel.
      const profile = getProfile();
      const counts = getRankAndCounts();
      const earned = new Set(getEarnedAchievements());
      if (profile.totalXp > 0 || earned.size > 0) {
        document.getElementById("profile-panel").hidden = false;
        document.getElementById("profile-rank").textContent = counts.rank;
        document.getElementById("profile-xp").textContent = profile.totalXp.toLocaleString();
        document.getElementById("profile-days").textContent = String(profile.daysPlayed.length);
        document.getElementById("profile-ach").textContent = `${counts.earned} / ${counts.total}`;
        const grid = document.getElementById("ach-grid");
        for (const a of XGAME_ACHIEVEMENTS) {
          const pill = document.createElement("div");
          pill.className = "ach-pill" + (earned.has(a.id) ? " earned" : "");
          pill.innerHTML = `<div class="ach-title-line">${earned.has(a.id) ? "★ " : ""}${a.title}</div>
            <div class="ach-detail-line">${a.detail}</div>`;
          grid.appendChild(pill);
        }
      }
    